import type React from "react"
import { useRef, useEffect } from "react"
import { Box, Typography } from "@mui/material"
import ChatMessage from "./ChatMessage"
import type { MessageDto } from "../../types/message";


interface ChatMessageListProps {
  messages: MessageDto[]
  userProfileId: number | undefined
}

const ChatMessageList: React.FC<ChatMessageListProps> = ({ messages, userProfileId }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages])

  if (messages.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          No hay mensajes en esta conversación
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto", mb: 2 }}>
      {messages.map((message, index) => {
        const isCurrentUser = message.senderProfileId === userProfileId
        const showAvatar = index === 0 || messages[index - 1].senderProfileId !== message.senderProfileId

        return (
          <ChatMessage
            key={message.id || index}
            message={message}
            isCurrentUser={isCurrentUser}
            showAvatar={showAvatar}
            userProfileId={userProfileId}
          />
        )
      })}
      <div ref={messagesEndRef} />
    </Box>
  )
}

export default ChatMessageList
